<template>
  <div class="user-wrapper">
<!--    <a style="cursor:pointer;margin-right: 20px" @click="down()">操作手册<a-icon type="download" /></a>-->
    <!--<header-online style="color: whitesmoke" class="action"/>-->
    <!--<header-notice style="color: whitesmoke" class="action"/>-->
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="avatar()"/>
        <span style="margin-left: 8px;color: #fff">{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="1">
          <router-link :to="{ name: 'settings' }">
            <a-icon type="setting"/>
            <span>账户设置</span>
          </router-link>
        </a-menu-item>
        <!--<a-menu-divider/>-->
        <a-menu-item key="3">
          <a href="javascript:;" @click="handleLogout">
            <a-icon type="logout"/>
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import HeaderNotice from './HeaderNotice'
import HeaderOnline from './HeaderOnline'
import { mapActions, mapGetters } from 'vuex'
import qs from 'qs'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'UserMenu',
  components: {
    HeaderNotice,
    HeaderOnline
  },
  methods: {
    down () {
      window.open(this.$_c + 'api/1/file/get_handbook_file?' + qs.stringify({ 'X-Auth-Token': this.$ls.get(ACCESS_TOKEN) }), '_blank')
    },
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout () {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
              window.location = process.env.VUE_APP_WEB_SERVER+'/#/login'
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .header-online {
    display: inline-block;
    transition: all 0.3s;

    span {
      vertical-align: initial;
    }
  }
</style>
